<template>
  <div class="centerCon">
    <div class="container">
      <div class="d-flex justify-content-center">
        <img src="../assets/images/logo.png" :width="300" :height="130" class="img-fluid" style="object-fit: cover" />
      </div>
      <div class="container pt-5">
        <div class="row">
          <div class="col-lg-6 mx-auto">
            <div class="card-register card-item-register">
              <div class="card-body">
                <h3 class="card-title text-center fs-24 lh-35 pb-4">
                  هاوبیر | پنل اساتید
                </h3>
                <form method="POST" class="pt-4" v-on:submit="handleSubmit">
                  <div class="input-box">
                    <label class="label-text">موبایل</label>
                    <div class="form-group">
                      <input onfocus="this.removeAttribute('readonly');" readonly required v-model="mobile"
                        class="form-control form--control form-control-register" type="text" name="name"
                        placeholder="*******0912" />
                      <span class="la la-user input-icon"></span>
                    </div>
                  </div>
                  <div class="input-box">
                    <label class="label-text">گذرواژه</label>
                    <div class="input-group input-group-register-password mb-4">
                      <span class="la la-lock input-icon"></span>
                      <input onfocus="this.removeAttribute('readonly');" readonly required v-if="!showPassword"
                        v-model="password" class="
                                      form-control
                                      form--control
                                      form-control-register-password
                                      password-field
                                    " type="password" name="password" placeholder="گذرواژه خود را وارد کنید" />
                      <input onfocus="this.removeAttribute('readonly');" readonly required v-if="showPassword"
                        v-model="password" class="
                                      form-control
                                      form--control
                                      form-control-register-password
                                      password-field
                                    " type="text" name="password" placeholder="گذرواژه خود را وارد کنید" />
                      <div @click="toggleShow()" class="input-group-append input-group-append-password">
                        <button class="
                                        btn
                                        theme-btn-register theme-btn-transparent
                                        toggle-password
                                      " type="button">
                          <i style="font-size: 20px" v-if="!showPassword" class="la la-eye"></i>
                          <i style="font-size: 20px" v-if="showPassword" class="la la-low-vision"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="btn-box">
                    <div class="
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                    pb-4
                                  ">
                      <div class="custom-control custom-checkbox fs-15">
                        <input type="checkbox" class="custom-control-input" id="rememberMeCheckbox" />
                        <label class="custom-control-label custom--control-label" for="rememberMeCheckbox">مرا به خاطر
                          بسپار</label>
                      </div>
                    </div>
                    <button :disabled="working" type="submit" class="btn theme-btn theme-btn-register-submit">
                      <div v-if="!working">
                        ورود به حساب کاربری
                        <i class="la la-arrow-left icon ml-1"></i>
                      </div>
                      <div v-if="working" class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                    <span style="font-family: sans-serif; font-size: 10px" class="mx-1 d-flex justify-content-center">
                      <span class="primCom"> نسخه&nbsp; </span>
                      {{ cnfigs.VERSION }}</span>&nbsp;
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Toast position="top-left" />
</template>

<script>
import axios from "axios";

import router from "../router/index";
import ls from "localstorage-slim";
import * as cnfigs from "../configs";

export default {
  name: "Login",
  data() {
    return {
      cnfigs: cnfigs,
      showPassword: false,
      working: false,
      mobile: "",
      password: "",
      errors: "",
    };
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    async handleSubmit(e) {
      // this.checkForm();
      e.preventDefault();
      this.working = true;
      await this.$recaptchaLoaded().then(
        () => {
          this.$recaptcha("login").then(
            async (token) => {
              await axios
                .post("/api/v1/teacher/user/login", {
                  mobile: this.toEngDigit(this.mobile),
                  password: this.toEngDigit(this.password),
                  "g-recaptcha-response": token,
                })
                .then((response) => {
                  if (response.status == 200 && response.data.data === "ok") {
                    ls.set("token", response.data.token);
                    ls.set("user", JSON.stringify(response.data.user));
                    this.working = false;
                    axios.defaults.headers.common["Authorization"] =
                      "Bearer " + ls.get("token");
                    router.push("/");
                  } else {
                    this.working = false;
                    this.$toast.add({
                      severity: "error",
                      summary: "عدم صحت اطلاعات وارد شده",
                      life: 5000,
                    });
                  }
                });
            });
        });
    },
    checkForm() {
      this.errors = [];

      if (this.total != 100) {
        this.errors.push("Total must be 100!");
      }

      if (!this.errors.length) {
        return true;
      }
    },
  },
};
</script>

<style></style>
